export type {Monitor} from './Monitor';
export {Severity} from './types';

import {Monitor, MonitorConfiguration} from './Monitor';
import {ExtraData, Severity} from './types';
import {BugsnagReporter} from './bugsnag';
import {ConsoleReporter} from './console';
import {DynatraceReporter} from './dynatrace';
import {LoggingReporter} from './logging';
import {wrapWithMonitor} from './util';

const cfg: MonitorConfiguration = {
    reporters: [
        [new BugsnagReporter(), [Severity.Error, Severity.Warning]],
        [new DynatraceReporter(), [Severity.Error, Severity.Warning]],
        new LoggingReporter(),
    ],
};

if (process.env.NODE_ENV !== 'production') {
    cfg.reporters.push(new ConsoleReporter());
}

export const monitor = new Monitor(cfg);
export const wrapWithModuleName =
    (module: string) =>
    <T extends Array<unknown>, U>(fn: (...args: T) => U, extra: ExtraData = {}) =>
        wrapWithMonitor(fn, monitor, {...extra, module});
